import React from 'react';

import { Chip } from '@infoods/lifebase-ui';
import { SubscriptionType } from '../../../shared/constants/user-info/subscription';

type SubscriptionTypeChipProps = {
  subscriptionType: SubscriptionType;
};
// TODO add utils to get humanize subscription type
const SubscriptionTypeChip = ({ subscriptionType }: SubscriptionTypeChipProps) => {
  switch (subscriptionType) {
    case 'REGULAR':
      return <Chip label="Regular Plan" size="small" />;
    case 'REACTIVATION':
      return <Chip label="Reactivation" size="small" color="info" />;
    default:
      return <Chip label={subscriptionType} size="small" />;
  }
};

export { SubscriptionTypeChip };
